module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/offline-analytic-4.7732c621.svg";